<template>
  <div class="flex h-full bg-blue-dark bg-cover layered" :style="{ 'background-image': 'url(' + image + ')' }">
    <div class="flex flex-col items-center justify-center w-full lg:max-w-sm bg-grey-lighter">
      <div class="px-4 sm:px-11 mb-12">
        <img :src="logo" alt="Van Santen Advies Logo" class="block">
      </div>
      <div class="w-full max-w-md px-8 sm:px-16">
        <h1 class="text-grey font-light" data-cy="login headline">Please log in</h1>
        <form @submit.prevent="login">
          <div class="form-error mt-4" data-cy="login error" v-if="error">
            {{ error.message }}
          </div>
          <div class="mt-8">
            <label for="text-input" class="form-label">Email:</label>
            <input v-model="username" type="email" id="text-input" autocapitalize="off" autofocus="autofocus" class="form-input" :class="{ 'error': error }" required>
          </div>
          <div class="mt-6">
            <label for="password-input" class="form-label">Password:</label>
            <input v-model="password" type="password" id="password-input" autocapitalize="off" class="form-input" :class="{ 'error': error }" required>
          </div>
          <div class="mt-6 text-left">
            <button type="submit" class="btn btn-primary bg-green-dark hover:bg-green-darker">Inloggen</button>
          </div>
        </form>
        <!-- <p class="mt-12 text-sm text-grey-darkest cursor-pointer hover:underline" @click="showModal = true">I don't remember my password</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: ''
    };
  },
  methods: {
    async login() {
      const { username, password } = this;
      await this.$store.dispatch('auth/login', { username, password });

      this.$router.push({ name: 'home' });
    }
  },
  computed: {
    ...mapState({
      error: state => state.auth.error
    }),
    image() {
      return require('@/assets/backgrounds/login-bg.jpg');
    },
    logo() {
      return require('@/assets/logo.png');
    }
  }
};
</script>

<style scoped>
.layered {
  box-shadow: inset 0 0 0 100vw rgba(0, 0, 0, 0.7);
}
</style>
